var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplefiligreeContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1fb6118d-8c5e-43d6-bfa4-95b1a407f19b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.69 68.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0V68.08H90.69V0H0ZM87.69,65.08H3V3H87.69v62.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.78,54.01c1.19-6.78,7.66-11.31,14.44-10.12,5.16,.91,9.21,4.95,10.12,10.12l.1,.56h2.06l-.14-.8c-.93-5.38-4.77-9.8-9.97-11.46,5.14-2.39,7.36-8.5,4.96-13.63-2.39-5.14-8.5-7.36-13.63-4.96-5.14,2.39-7.36,8.5-4.96,13.63,1.02,2.19,2.78,3.94,4.96,4.96-5.21,1.66-9.06,6.08-9.99,11.46l-.13,.8h2.06l.12-.57Zm4.08-20.97c0-4.53,3.66-8.2,8.18-8.21,4.53,0,8.2,3.66,8.21,8.18s-3.66,8.2-8.18,8.21c0,0,0,0-.01,0-4.52,0-8.18-3.66-8.2-8.18h0Z",
    style: {
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.18,
    y1: 17.85,
    x2: 37.44,
    y2: 17.85,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.18,
    y1: 29.3,
    x2: 37.44,
    y2: 29.3,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplefiligreeContact);
export default __webpack_public_path__ + "static/media/simple filigree - contact.8decd6f50100ac7f7032ecdb523b17da.svg";
export { ForwardRef as ReactComponent };